import { StepBase } from './StepBase'
import { PageStepType } from './PageTypes';
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { DataQuery } from '../utils/DataQuery';
import { DataRecord } from '../utils/DataRecord';
import { DataTools } from '../utils/DataTools';
import { ChartDataSet, PieChartDataPoint } from '../utils/ChartData';
import { ChartDataColors } from '../utils/ChartDataColor';

export type StepChartType = 'Pie' | 'Bar' | 'Line';

export class StepChart extends StepBase
{
	logicRef: LogicEngine | undefined;
	records: DataRecord[] = [];

	/** Any options set with the ChartOption command */
	chartOptions: { [keyName: string]: string } = {};

	/** Type of chart to display */
	chartType: StepChartType = 'Line';

	/* All Data for Output **/
	dataSets: (any[] | any[][]) = [];

	currentDataSet: any[] = [];

	dataMaps: { [field_id: string]: string } = {};

	/** Add an option using ChartOptions option name = step_option column, value in text_en column */
	async addOption(step: PageStepType)
	{
		if (!this.logicRef)
			throw "Exception: should not happen but logicRef in StepTabs is null";

		// Key is the configuration lookup key
		let key = step.step_option ? step.step_option : "";
		key = key.toLowerCase().trim();

		let value = step.option_1 ? this.logicRef.processTextReplacement(step.option_1) : "";
		this.chartOptions[key] = value;
	}

	/** From DataMap field_id = Field, text_en = Value */
	addDataMap(step: PageStepType)
	{
		this.dataMaps[DataTools.internalValidateString(step.field_id)] = DataTools.internalValidateString(step.text_en);
	}

	beginDataSet()
	{
		this.dataMaps = {};
		this.currentDataSet = [];
	}

	endDataSet()
	{
		if (this.chartType === 'Pie')
			this.dataSets = this.currentDataSet;
		else
			this.dataSets.push(this.currentDataSet);
	}

	importDataToSet()
	{
		let data: any = {};

		// Set the default color, can be changed in "Map Data" command
		if (this.chartType === "Pie")
			data.color = ChartDataColors.nextColor();

		/** Loop through the data maps */
		for (const rawKey of Object.keys(this.dataMaps))
		{
			const targetVar = this.logicRef?.processTextReplacement(rawKey);
			let targetVal: string | number | undefined = this.logicRef?.processTextReplacement(this.dataMaps[rawKey]);

			if (typeof (targetVal) === "string" && /^[\-0-9\.]+$/.test(targetVal))
			{
				try
				{
					const targetNum = parseFloat(targetVal);
					targetVal = targetNum;
				} catch (e)
				{
				}
			}

			data[DataTools.internalValidateString(targetVar).toLowerCase().trim()] = targetVal;

			if (LogicEngine.debugOutput)
				console.log("Data Set Map", targetVar, "=", targetVal);
		}

		if (!this.currentDataSet)
			this.currentDataSet = [];

		this.currentDataSet.push(data);
	}

	/**
	 *  Process the data type here.
	 *  Load the data related to the Query data type.
	 */
	async processStep(logic: LogicEngine): Promise<boolean>
	{
		this.logicRef = logic;
		await super.processStep(logic);

		if (this.options.checkOption("Pie"))
			this.chartType = "Pie";
		else if (this.options.checkOption("Line"))
			this.chartType = "Line";
		else if (this.options.checkOption("Bar"))
			this.chartType = "Bar";

		return true;
	}

	async processEndChart(step: PageStepType): Promise<void>
	{
	}
}
